var _rect, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Restaurant supplies including cutlery, napkins, and gloves") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#edf1f4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 100v145M120 100v100c0 60 70 60 70 0V100M155 245v180",
    fill: "none",
    stroke: "#162d45",
    strokeWidth: 17,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275 100c55 0 66 115 8 160l-8 165",
    fill: "#fff",
    stroke: "#162d45",
    strokeWidth: 17,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410 145h215v250H410z",
    fill: "#fff",
    stroke: "#162d45",
    strokeWidth: 14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445 110h215v250H445z",
    fill: "#f3e5cf",
    stroke: "#162d45",
    strokeWidth: 14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490 205h125M490 250h100",
    stroke: "#c49356",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 405,
    r: 45,
    fill: "#c49356",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc);
export default __webpack_public_path__ + "static/media/misc.d6e6cbf57a73f6c2d3862081f321dfcb.svg";
export { ForwardRef as ReactComponent };